const EMOJIS = ["👍", "⭐"];

// Lightweight founder acknowledgement. Founders toggle 👍/⭐; everyone sees counts.
export const NoteReactions = ({ note, canReact, myName, onReact, compact = false }) => {
  const reactions = note.reactions || [];
  const summary = EMOJIS.map((e) => {
    const users = reactions.filter((r) => r.emoji === e).map((r) => r.user);
    return { emoji: e, count: users.length, mine: users.includes(myName), users };
  });
  const anyReactions = summary.some((s) => s.count > 0);
  if (!canReact && !anyReactions) return null;

  return (
    <div className={`flex items-center gap-1.5 ${compact ? "" : "flex-wrap"}`} data-testid={`note-reactions-${note.id}`}>
      {summary.map((s) => {
        if (!canReact && s.count === 0) return null;
        return (
          <button
            key={s.emoji}
            type="button"
            data-testid={`note-react-${s.emoji === "👍" ? "thumb" : "star"}-${note.id}`}
            disabled={!canReact}
            title={s.users.length ? s.users.join(", ") : (canReact ? "Add reaction" : "")}
            onClick={(e) => { e.stopPropagation(); if (canReact) onReact(note, s.emoji); }}
            className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[11px] font-semibold transition-colors ${s.mine ? "border-[#E0A82E] bg-[#FBF3DC] text-[#8A6314]" : "border-black/10 bg-white/70 text-[#5C6B7B]"} ${canReact ? "hover:border-[#E0A82E] hover:bg-[#FBF3DC] cursor-pointer" : "cursor-default"}`}
          >
            <span className="leading-none">{s.emoji}</span>
            {s.count > 0 && <span className="leading-none">{s.count}</span>}
          </button>
        );
      })}
    </div>
  );
};
